// Copyright (C) 2026, Meritic Inc.

/**
 * Darwin URL properties — combines REACT_APP_DARWIN_ADDRESS (base) with
 * each relative API path env var at call time. This avoids ${VAR} interpolation
 * in env files, which Docker env_file does not support.
 *
 * @author Nipun Gupta (nipun@getanko.com)
 */

const base = (): string => process.env.REACT_APP_DARWIN_ADDRESS ?? "";

// Artifacts
export const getPopulateArtifactUrl = (): string => `${base()}${process.env.REACT_APP_POPULATE_ARTIFACT_API ?? ""}`;
export const getListArtifactsUrl = (): string => `${base()}${process.env.REACT_APP_LIST_ARTIFACTS_API ?? ""}`;
export const getDownloadReportUrl = (): string => `${base()}${process.env.REACT_APP_DOWNLOAD_REPORT_API ?? ""}`;

// Slack
export const getSlackChannelsUrl = (): string => `${base()}${process.env.REACT_APP_SLACK_CHANNELS_API ?? ""}`;

// Eva Report Template
export const getEvaReportTemplateUrl = (): string => `${base()}${process.env.REACT_APP_REPORT_TEMPLATE_API ?? ""}`;

// Eva Agents
export const getEvaAgentUrl = (): string => `${base()}${process.env.REACT_APP_EVA_AGENT_API ?? ""}`;
export const getEvaAgentListUrl = (): string => `${base()}${process.env.REACT_APP_EVA_AGENT_LIST_API ?? ""}`;
export const getEvaAgentDuplicateUrl = (): string => `${base()}${process.env.REACT_APP_EVA_AGENT_DUPLICATE_API ?? ""}`;

// Eva Tools
export const getEvaToolUrl = (): string => `${base()}${process.env.REACT_APP_EVA_TOOL_API ?? ""}`;
export const getEvaToolListUrl = (): string => `${base()}${process.env.REACT_APP_EVA_TOOL_LIST_API ?? ""}`;
export const getEvaToolDuplicateUrl = (): string => `${base()}${process.env.REACT_APP_EVA_TOOL_DUPLICATE_API ?? ""}`;

// Eva Prompts
export const getEvaPromptUrl = (): string => `${base()}${process.env.REACT_APP_EVA_PROMPT_API ?? ""}`;
export const getEvaDocUrl = (): string => `${base()}${process.env.REACT_APP_EVA_DOC_API ?? ""}`;
export const getEvaTemplateValidateUrl = (): string =>
  `${base()}${process.env.REACT_APP_EVA_TEMPLATE_VALIDATE_API ?? ""}`;

// Eva Skills
export const getEvaSkillUrl = (): string => `${base()}${process.env.REACT_APP_EVA_SKILL_API ?? ""}`;
export const getEvaSkillListUrl = (): string => `${base()}${process.env.REACT_APP_EVA_SKILL_LIST_API ?? ""}`;

// Chat Sessions
export const getChatMessageUrl = (): string => `${base()}${process.env.REACT_APP_CHAT_MESSAGE_API ?? ""}`;
export const getChatSessionUrl = (): string => `${base()}${process.env.REACT_APP_CHAT_SESSION_API ?? ""}`;
export const getSaveChatSessionUrl = (): string => `${base()}${process.env.REACT_APP_SAVE_CHAT_SESSION_API ?? ""}`;
export const getListChatSessionsUrl = (): string => `${base()}${process.env.REACT_APP_LIST_CHAT_SESSIONS_API ?? ""}`;
export const getUpdateChatHeadersUrl = (): string => `${base()}${process.env.REACT_APP_UPDATE_CHAT_HEADERS_API ?? ""}`;
export const getDuplicateChatSessionUrl = (): string =>
  `${base()}${process.env.REACT_APP_DUPLICATE_CHAT_SESSION_API ?? ""}`;
export const getRefreshAgentStateUrl = (): string => `${base()}${process.env.REACT_APP_REFRESH_AGENT_STATE_API ?? ""}`;
export const getChatUsageUrl = (): string => `${base()}${process.env.REACT_APP_CHAT_USAGE_API ?? ""}`;
export const getParseTableUrl = (): string => `${base()}${process.env.REACT_APP_PARSE_TABLE_API ?? ""}`;

// Memory
export const getAnalystMemoryUrl = (): string => `${base()}${process.env.REACT_APP_ANALYST_MEMORY_API ?? ""}`;
export const getCloneAnalystMemoryUrl = (): string =>
  `${base()}${process.env.REACT_APP_CLONE_ANALYST_MEMORY_API ?? ""}`;
export const getMemoryUsageUrl = (): string => `${base()}${process.env.REACT_APP_MEMORY_USAGE_API ?? ""}`;

// Experiments
export const getEvaExperimentUrl = (): string => `${base()}${process.env.REACT_APP_EVA_EXPERIMENT_API ?? ""}`;
export const getEvaExperimentRunUrl = (): string => `${base()}${process.env.REACT_APP_EVA_EXPERIMENT_RUN_API ?? ""}`;
export const getEvaExperimentListUrl = (): string => `${base()}${process.env.REACT_APP_EVA_EXPERIMENT_LIST_API ?? ""}`;

// Swagger
export const getDarwinSwaggerUrl = (): string => `${base()}/docs`;
